import "antd/es/page-header/style";
import _PageHeader from "antd/es/page-header";
var _excluded = ["className", "noPadding", "backIcon"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from 'react';
import classNames from 'classnames';
import { IconArrowLeftOutlined } from '@osui/icons';
import './index.less';
var clsPrefix = 'osui-page-header';

var PageHeader = function PageHeader(_ref) {
  var className = _ref.className,
      noPadding = _ref.noPadding,
      backIcon = _ref.backIcon,
      props = _objectWithoutProperties(_ref, _excluded);

  var innerClassName = classNames(className, clsPrefix, _defineProperty({}, "".concat(clsPrefix, "-no-padding"), noPadding));
  var innerBackIcon = backIcon !== null && backIcon !== void 0 ? backIcon : /*#__PURE__*/React.createElement(IconArrowLeftOutlined, null);
  return /*#__PURE__*/React.createElement(_PageHeader, _objectSpread(_objectSpread({
    className: innerClassName
  }, props), {}, {
    backIcon: innerBackIcon
  }));
};

export default PageHeader;
//# sourceMappingURL=index.js.map